// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)

import MovieSearchController from "./movie_search_controller"
application.register("movie-search", MovieSearchController)

import PasskeyRegistrationController from "./passkey_registration_controller"
application.register("passkey-registration", PasskeyRegistrationController)

import PasskeyAuthenticationController from "./passkey_authentication_controller"
application.register("passkey-authentication", PasskeyAuthenticationController)

import ClankerChatController from "./clanker_chat_controller"
application.register("clanker-chat", ClankerChatController)

import ChoreTimerController from "./chore_timer_controller"
application.register("chore-timer", ChoreTimerController)

import LawnTasksController from "./lawn_tasks_controller"
application.register("lawn-tasks", LawnTasksController)
